import {ErrorModel} from '../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../root';
import {resultsDto} from './defaultResponseModel/results';
const FUNCTION_CODE = 'GET_RESULTS';

export async function getResults(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/codev/result/${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );
            
        const result = resultsDto.from(response.data);
            
        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
